@if (intro()) {
    <woa-content-message class="order-type-selection-intro" [text]="intro()"></woa-content-message>
}
<div class="order-type-selection-actions">
    @if (canOrderAtTable()) {
        <woa-button id="button-order-at-table" [label]="orderAtTableLabel()"
                    [prominence]="ButtonProminence.LOW"
                    (onActivate)="onOrderTypeSelected.emit(OrderType.ORDER_AT_TABLE)"></woa-button>
    }
    @if (canOrderAhead()) {
        <woa-button id="button-order-ahead" [label]="orderAheadLabel()"
                    [prominence]="ButtonProminence.LOW"
                    (onActivate)="onOrderTypeSelected.emit(OrderType.ORDER_AHEAD)"></woa-button>
    }
    @if (canOrderDelivery()) {
        <woa-button id="button-order-delivery" [label]="deliveryLabel()"
                    [prominence]="ButtonProminence.LOW"
                    (onActivate)="onOrderTypeSelected.emit(OrderType.ORDER_DELIVERY)"></woa-button>
    }
</div>
